export default __webpack_public_path__ + "static/media/rfcheckout_2.fff599fa.png";